import { useMemo } from 'react';
import { BLUE, GREEN, ORANGE, RED } from 'pos-client/utils/colours.ts';
import type { JobStatusMapFeModel } from 'pos-shared/models/schedulingSchema.ts';

export const useJobStatusColourMapper = () => {
  const jobStatuses: JobStatusMapFeModel = useMemo(
    () => [
      { id: 'Authorized', color: 'rgba(197,197,197, 0.3)' },
      { id: 'Unauthorized', color: 'transparent' },
      { id: 'bypassed', color: '#8c8c8c' },
      { id: 'to do', color: BLUE.background as string },
      { id: 'sub contracted', color: '#004FBD' },
      { id: 'in progress', color: ORANGE.background as string },
      { id: 'awaiting caf', color: ORANGE.background as string },
      { id: 'in progress - overrunning', color: RED.background as string },
      { id: 'complete', color: GREEN.background as string },
      { id: 'completed', color: GREEN.background as string },
      { id: 'conflict', color: 'white' },
    ],
    []
  );

  return { jobStatuses };
};

export const useJobStatusBgColor = (status: string) => {
  const { jobStatuses } = useJobStatusColourMapper();

  const getColorForStatus = (statusId: string) => {
    const foundStatus = jobStatuses.find(
      (jobStatus) => jobStatus.id === statusId
    );
    return foundStatus ? foundStatus.color : '#F2F9FF';
  };

  return getColorForStatus(status);
};

// if these statuses are to come from static config then the styling data needs to come from there as well
